import { useEffect, useState } from 'react';
/**
 * This hook is used to return if viewport orientation is portrait or not.
 */
function useIsPortraitOrientation() {
    const [isPortrait, setPortrait] = useState(false);
    useEffect(() => {
        const event = 'change';
        const mediaQueryList = window.matchMedia('(orientation: portrait)');
        const handleOrientationChange = (mql) => {
            setPortrait(mql.matches);
        };
        mediaQueryList.addEventListener(event, handleOrientationChange);
        return () => {
            mediaQueryList.removeEventListener(event, handleOrientationChange);
        };
    }, []);
    return isPortrait;
}
export { useIsPortraitOrientation, };
//# sourceMappingURL=use-is-portrait-orientation.js.map